import { Injectable } from '@angular/core';
import { EmailSignature } from '../email-signature';
import { HttpService } from '../service/http.service';
import { Language } from '../language';

@Injectable({
  providedIn: 'root'
})
export class EmailSignatureService {

  emailSignatures: EmailSignature[] = [];

  constructor(
    private httpService: HttpService
  ) {
    this.httpService.getEmailSignaturesByUser().subscribe(res => {
      this.emailSignatures = res;
    });
  }

  getEmailSignatureByLanguage(language: Language) {
    if (!language) {
      return this.getDefaultEmailSignature(this.emailSignatures);
    }
    for (let signature of this.emailSignatures) {
      if (signature.language.id == language.id) {
        return signature;
      }
    }
    return this.getDefaultEmailSignature(this.emailSignatures);
  }

  private getDefaultEmailSignature(signatures: EmailSignature[]) {
    if (signatures.length > 0) {
      return signatures[0];
    } else {
      return null;
    }
  }
}